"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAppLayout = void 0;
var _reactSdk = require("@100mslive/react-sdk");
var _constants = require("../../common/constants");
var useAppLayout = function useAppLayout(path) {
  return (0, _reactSdk.useHMSStore)((0, _reactSdk.selectAppDataByPath)(_constants.APP_DATA.appLayout, path));
};
exports.useAppLayout = useAppLayout;